import { render, staticRenderFns } from "./PostcodeSearch.vue?vue&type=template&id=505c4dc2&scoped=true"
import script from "./PostcodeSearch.vue?vue&type=script&lang=js"
export * from "./PostcodeSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c4dc2",
  null
  
)

export default component.exports